import { render, staticRenderFns } from "./popoverBtn.vue?vue&type=template&id=03a0fbb3&scoped=true&"
import script from "./popoverBtn.vue?vue&type=script&lang=js&"
export * from "./popoverBtn.vue?vue&type=script&lang=js&"
import style0 from "./popoverBtn.vue?vue&type=style&index=0&id=03a0fbb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a0fbb3",
  null
  
)

export default component.exports